import { Component, inject } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FirebaseAuthService } from '../../../services/firebase.auth.service';
import { Router } from '@angular/router';
import { FirebaseFirestoreService } from '../../../services/firebase.firestore.service';
import { HowToSucceedComponent } from '../how-to-succeed/how-to-succeed.component';
import { DialogService } from 'primeng/dynamicdialog';
import { DialogModule } from 'primeng/dialog';
import { ContactSupportComponent } from '../contact-support/contact-support.component';
import { PersonalInformationComponent } from '../personal-information/personal-information.component';
import { ConfirmationService } from 'primeng/api';
import { DeleteAccountReauthModalComponent } from '../delete-account-reauth-modal/delete-account-reauth-modal.component';

@Component({
  selector: 'app-profile-tab',
  standalone: true,
  imports: [CommonModule, DialogModule],
  providers: [DialogService],
  templateUrl: './profile-tab.component.html',
  styleUrls: ['./profile-tab.component.scss']
})
export class ProfileTabComponent {
  firebaseAuthService = inject(FirebaseAuthService);
  firebaseFirestoreService = inject(FirebaseFirestoreService);
  router = inject(Router);
  dialogService = inject(DialogService);
  confirmationService = inject(ConfirmationService);
  userProfile = this.firebaseFirestoreService.getUserProfile();
  completedBatches = this.firebaseFirestoreService.getCompletedBatches();
  completedBatchesCount = 0;

  constructor() {
    this.getCompletedBatches();
  }

  getCompletedBatches() {
    this.completedBatches.subscribe((batches) => {
      this.completedBatchesCount = batches.length;    
    });
  }

  async logout() {
    try {
      await this.firebaseAuthService.logout();
      this.router.navigate(['/login']);
    } catch (error) {
      console.error('Logout failed:', error);
    }
  }

  async deleteAccount() {
    this.confirmationService.confirm({
      message: 'Are you sure you want to delete your account? This action is irreversible.',
      header: 'Delete Account',
      icon: 'pi pi-exclamation-triangle',
      closable: true,
      rejectVisible: true,
      acceptVisible: true,
      acceptLabel: 'Delete',
      rejectLabel: 'Cancel',
      position: 'bottom',
      accept: () => {
        this.confirmationService.close();
        this.openDeleteAccountModal();
      },
      reject: () => {
        console.log('Delete account cancelled');
      }
    });
  }

  openDeleteAccountModal() {
    this.dialogService.open(DeleteAccountReauthModalComponent, {
      modal: true,
      closable: true,
      closeOnEscape: true,
      showHeader: true,
      header: 'Verify Your Identity',
      position: 'bottom',
      contentStyle: {
        'height': 'auto',
        'padding': '0'
      },
      style: {
        'width': '100%',
        'max-width': '500px',
        'border-radius': '12px',
        'border': 'none'
      }
    });
  }

  navigateToHowToSucceed() {
    this.dialogService.open(HowToSucceedComponent, {
      modal: true,
      closable: true,
      closeOnEscape: true,
      showHeader: false,
      contentStyle: {
        'height': '100%',
        'padding': '0'
      },
      style: {
        'width': '100%',
        'max-width': '640px',
        'height': '100vh',
        'max-height': 'none',
        'border-radius': '0',
        'border': 'none'
      }
    });
  }

  navigateToContactSupport() {
    this.dialogService.open(ContactSupportComponent, {
      modal: true,
      closable: true,
      closeOnEscape: true,
      showHeader: false,
      contentStyle: {
        'height': '100%',
        'padding': '0'
      },
      style: {
        'width': '100%',
        'max-width': '640px',
        'height': '100vh',
        'max-height': 'none',
        'border-radius': '0',
        'border': 'none'
      }
    });
  }

  navigateToPersonalInformation() {
    this.dialogService.open(PersonalInformationComponent, {
      modal: true,
      closable: true,
      closeOnEscape: true,
      showHeader: false,
      contentStyle: {
        'height': '100%',
        'padding': '0'
      },
      style: {
        'width': '100%',
        'max-width': '640px',
        'height': '100vh',
        'max-height': 'none',
        'border-radius': '0',
        'border': 'none'
      }
    });
  }


} 